import {ChangeDetectionStrategy, Component, Input, TemplateRef} from '@angular/core';

import {SeasonTableDataModel} from './season-table-data.model';

@Component({
  selector: 'tisa-season-table',
  templateUrl: './season-table.component.html',
  styleUrls: ['./season-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SeasonTableComponent {
  @Input() entries: SeasonTableDataModel[] | undefined;

  @Input() liveMatchesTemplate: TemplateRef<any> | undefined;

  @Input() onEntryClicked!: (entry: SeasonTableDataModel) => void;

  @Input() isLoading = false;

  readonly skeletonItems = Array(10).fill(0);

  get hasFormData(): boolean {
    return this.entries?.some(entry => entry.last_five_matches?.length > 0) ?? false;
  }
}
